import React from "react";
import { Space } from "antd";
import { AxAutoComplete, AxDivider, AxButton } from "@dynata/axiom3";

const options = [{ value: "road" }, { value: "street" }, { value: "wall" }];

const optionsTwo = [
  { value: "samsung" },
  { value: "apple" },
  { value: "xiaomi" },
];

const optionsThree = [
  { value: "galaxy" },
  { value: "iphone" },
  { value: "note" },
];

class AutoComplete extends React.Component {
  render() {
    return (
      <div className="section" id="autocomplete">
        <h3>Auto Complete</h3>
        <Space direction="vertical">
          <p>Autocomplete function of input field.</p>
        </Space>

        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>

        <Space size="large" direction="vertical">
          <pre>{`
<AxAutoComplete
  size="large"
  options={[{ value: "road" }, { value: "street" }, { value: "wall" }]}
  placeholder="Autocomplete Input"
  style={{ width: 200 }}
/>
`}</pre>

          <div className="prop-header">
            <p className="props-title">Props</p>
            <p>
              For AntD props, visit{" "}
              <AxButton
                size="small"
                type="link"
                target="_blank"
                href="https://ant.design/components/auto-complete/#API"
              >
                https://ant.design/components/auto-complete/#API
              </AxButton>
            </p>
          </div>

          <table className="props-table">
            <thead>
              <tr>
                <th>Property</th>
                <th>Description</th>
                <th>Type</th>
                <th>Default</th>
                <th>Version</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>size</td>
                <td>Size of AutoComplete</td>
                <td>
                  <code>small</code> | <code>medium</code> | <code>large</code>
                </td>
                <td>medium</td>
                <td></td>
              </tr>
              <tr>
                <td>allowClear</td>
                <td>Show clear button</td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>autoFocus</td>
                <td>If get focus when component mounted</td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>backfill</td>
                <td>If backfill selected item the input when using keyboard</td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>children (for customize input element)</td>
                <td>Customize input element</td>
                <td>
                  HTMLInputElement | HTMLTextAreaElement |
                  React.ReactElement&lt;InputProps&gt;
                </td>
                <td>&lt;Input /&gt;</td>
                <td></td>
              </tr>
              <tr>
                <td>children (for dataSource)</td>
                <td>Data source to auto complete</td>
                <td>
                  React.ReactElement&lt;OptionProps&gt; |
                  Array&lt;React.ReactElement&lt;OptionProps&gt;&gt;
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>defaultActiveFirstOption</td>
                <td>Whether active first option by default</td>
                <td>boolean</td>
                <td>true</td>
                <td></td>
              </tr>
              <tr>
                <td>defaultOpen</td>
                <td>Initial open state of dropdown</td>
                <td>boolean</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>defaultValue</td>
                <td>Initial selected option</td>
                <td>string</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>disabled</td>
                <td>Whether disabled select</td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>popupClassName</td>
                <td>The className of dropdown menu</td>
                <td>string</td>
                <td>-</td>
                <td>4.23.0</td>
              </tr>
              <tr>
                <td>dropdownMatchSelectWidth</td>
                <td>
                  Determine whether the dropdown menu and the select input are
                  the same width. Default set <code>min-width</code> same as
                  input. Will ignore when value less than select width.{" "}
                  <code>false</code> will disable virtual scroll
                </td>
                <td>boolean | number</td>
                <td>true</td>
                <td></td>
              </tr>
              <tr>
                <td>filterOption</td>
                <td>
                  If true, filter options by input, if function, filter options
                  against it. The function will receive two arguments,{" "}
                  <code>inputValue</code> and <code>option</code>, if the
                  function returns true, the option will be included in the
                  filtered set; Otherwise, it will be excluded
                </td>
                <td>boolean | function(inputValue, option)</td>
                <td>true</td>
                <td></td>
              </tr>
              <tr>
                <td>notFoundContent</td>
                <td>Specify content to show when no result matches</td>
                <td>string</td>
                <td>
                  <code>Not Found</code>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>open</td>
                <td>Controlled open state of dropdown</td>
                <td>boolean</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>options</td>
                <td>
                  Select options. Will get better perf than jsx definition
                </td>
                <td>
                  <code>{`{ label, value }[]`}</code>
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>placeholder</td>
                <td>The placeholder of input</td>
                <td>string</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>status</td>
                <td>Set validation status</td>
                <td>'error' | 'warning'</td>
                <td>-</td>
                <td>4.19.0</td>
              </tr>
              <tr>
                <td>value</td>
                <td>Selected option</td>
                <td>string</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onBlur</td>
                <td>Called when leaving the component</td>
                <td>
                  <code>{`function()`}</code>
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onChange</td>
                <td>
                  Called when selecting an option or changing an input value
                </td>
                <td>
                  <code>{`function(value)`}</code>
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onDropdownVisibleChange</td>
                <td>Call when dropdown open</td>
                <td>
                  <code>{`function(open)`}</code>
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onFocus</td>
                <td>Called when entering the component</td>
                <td>
                  <code>{`function()`}</code>
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onSearch</td>
                <td>Called when searching items</td>
                <td>
                  <code>{`function(value)`}</code>
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onSelect</td>
                <td>
                  Called when a option is selected. param is option's value and
                  option instance
                </td>
                <td>
                  <code>{`function(value, option)`}</code>
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>onClear</td>
                <td>Called when clear</td>
                <td>function</td>
                <td>-</td>
                <td>4.6.0</td>
              </tr>
              <tr>
                <td>...others</td>
                <td>
                  All extra props are passed down to the{" "}
                  <>
                    <AxButton
                      size="small"
                      type="link"
                      target="_blank"
                      href="https://4x.ant.design/components/auto-complete/#API"
                    >
                      {`<AutoComplete />`}
                    </AxButton>
                  </>{" "}
                  component.
                </td>
                <td></td>
                <td>-</td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <div className="prop-header">
            <p className="props-title">Methods</p>
          </div>
          <table className="props-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Version</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <code>{`blur()`}</code>
                </td>
                <td>Remove focus</td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <code>{`focus()`}</code>
                </td>
                <td>Get focus</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </Space>

        <Space size="large" direction="vertical">
          <pre>{`
<AxAutoComplete
  size="large"
  options={options}
  placeholder="Autocomplete Input"
  style={{ width: 200 }}
/>

<AxAutoComplete
  options={options}
  placeholder="Autocomplete Input"
  style={{ width: 200 }}
/>

<AxAutoComplete
  size="small"
  options={options}
  placeholder="Autocomplete Input"
  style={{ width: 200 }}
/>
`}</pre>
          <Space direction="vertical">
            <AxAutoComplete
              size="large"
              options={options}
              placeholder="Autocomplete Input"
              style={{ width: 200 }}
            />

            <AxAutoComplete
              options={optionsTwo}
              placeholder="Autocomplete Input"
              style={{ width: 200 }}
            />

            <AxAutoComplete
              size="small"
              options={optionsThree}
              placeholder="Autocomplete Input"
              style={{ width: 200 }}
            />
          </Space>
        </Space>
      </div>
    );
  }
}
export default AutoComplete;
